<template>
  <div>
    <img
        :src="icon"
        class="icon">

    <h1 class="account-verification__step__title title">
      {{ title }}
    </h1>

    <div>
      <div class="step">
        1. Guide the user through the instructions below.
      </div>

      <ul class="step__list">
        <li
            v-for="subStep in subSteps"
            :key="subStep"
            class="step__item">
          {{ subStep }}
        </li>
      </ul>
    </div>

    <div>
      <div class="step">
        2. Proceed to the next screen.
      </div>
      <div class="final-step">
        Once the customer generates their code, click Continue.
      </div>
    </div>

    <div
        class="account-verification__step__buttons-container">
      <el-button
          plain
          type="primary"
          class="account-verification__step__button account-verification__step__button-white"
          @click="notifyBack">
        {{ backButtonText }}
      </el-button>
      <el-button
          type="primary"
          class="account-verification__step__button"
          @click="notifyContinue">
        {{ processButtonText }}
      </el-button>
    </div>
  </div>
</template>

<script>
import ProcessingInfo from "../shared/ProcessingInfo";
import { createNamespacedHelpers as module } from "vuex";

const { mapGetters: accountGetters } = module("db/account");

export default {
  name: "RingAppControlCenterInstructions",
  components: { ProcessingInfo },
  emits: ["previousStepRequested", "complete", "errorNotification"],
  inject: ["VERIFICATION_METHODS_MAP"],
  props: {
    verificationMethodType: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      title: null,
      backButtonText: null,
      processButtonText: null,
      subSteps: null,
    };
  },
  computed: {
    ...accountGetters(["customerId"]),
  },
  mounted() {
    this.initialize();
  },
  beforeDestroy() {
    this.$emit("errorNotification", null);
  },
  methods: {
    initialize() {
      this.title = "Let’s help the user verify their account.";
      this.backButtonText = "Try Another Method";
      this.processButtonText = "Continue";

      this.subSteps = [
        "Log into the Ring mobile app",
        "Open the side menu and select Control Center",
        'Tap "Account Verification"',
        'Scroll down and tap "Customer Support Verification"',
        'Tap "Generate Code"',
      ];
    },
    notifyContinue() {
      this.$emit("nextStepRequested", true);
    },
    notifyBack() {
      this.$emit("errorNotification", null);
      this.$emit("previousStepRequested", true);
    },
  },
};
</script>

<style scoped>
.icon {
  width: 30px;
  height: 45px;
}

.title {
  margin-bottom: 24px;
}

.step {
  width: 570px;
  height: 24px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #424242;
  padding-top: 16px;
  border-top: solid 1px #dee5ec;
}

.step__item {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #6e6e6e;
}

.final-step {
  width: 570px;
  height: 24px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #6e6e6e;
  margin-top: 2px;
  padding-bottom: 16px;
  border-bottom: solid 1px #dee5ec;
  margin-bottom: 16px;
}

.step__list {
  margin-top: 2px;
  padding-left: 1.2em;
}

/* This is set by additionalCustomIconStyles computed property */
.icon__custom-email-icon {
  width: 40px;
  height: 28px;
}
</style>
